"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.README_URL = void 0;
exports.README_URL = 'https://github.com/OvidijusParsiunas/speech-to-element';
